/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Treatment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Treatment({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentBooking/Content/Treatment"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let patientBookingAppointmentTxTxCardNameValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.appointment.tx.tx_card.name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let patientBookingAppointmentTxTxStatusName0NameValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking.appointment.tx.tx_status_name.0.name',
})
  return (<React.Fragment
>
<div
  data-testid="Treatment.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2i9IjI': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="inline"
 overflowX="hidden"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 size="small"
 color={dtColorsNeutral900}
 data="patient.booking.appointment.tx.tx_card.name"
 text={patientBookingAppointmentTxTxCardNameValueData}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color={dtColorsNeutral900}
 data="patient.booking.appointment.tx.tx_status_name.0.name"
 text={patientBookingAppointmentTxTxStatusName0NameValueData}
/>
)}
</TysiaTag>
</div>
{children}
</React.Fragment>)
}